import adMindDetails from '../../components/AdMind/detail';

const tracking = () => {
  // Push GTM and GA4 detail event
  const productJson = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  const currentVariantId = Number(document.querySelector('input[name="id"]').value);
  // TODO: adMindDetails should be refactored in the future
  adMindDetails({
    product: productJson,
    currentVariant: productJson.variants.find((variant) => variant.id === currentVariantId),
  });
};

export default tracking;
